import React from 'react';
import DetailsBtn from './ModalPortfolio'
import '../../../Styles/work.css'

const Work = ({title, descComp, img, img2, img3, link1, link2, badge }) => {

    return (
        <div className="overlayone">
        <div className="image-container">
          <img src={img} alt="overlay" className="img-fluid o-img" />
          <img src={img2} alt="overlay-2" className="img-fluid o-img hidden" />
          <img src={img3} alt="overlay-3" className="img-fluid o-img hidden" />
        </div>
        <div className="overlayinn">
          {badge && <span className="o-work-badge">{badge}</span>}
          <h4>{title}</h4>
          <p className="truncate-text">{descComp}</p>
          <DetailsBtn title={title} img1={img} img2={img2} img3={img3} desc={descComp} link1={link1} link2={link2}></DetailsBtn>
        </div>
      </div>

    );

};
export default Work;